import styled from "styled-components"

import busImage from "../../../../assets/Mayo/bus.png"
import wheelChairImage from "../../../../assets/Mayo/Wheelchair_icon.svg"

import MayoFooter from "../common/MayoFooter"
import ListBox from "../common/ListBox"
import LocationListItem from "../common//LocationListItem"
import DottedListItem from "../common//DottedListItem"
import MayoCareItem from "../common//MayoCareItem"
import MayoLogo from "../common//MayoLogo"
import Back from "../common//Back"
import bgImg from "../../../../assets/Mayo/bg_1_for_videe_pages.svg"
import { useEffect } from "react"

const LOCATIONS_LIST = [
  {address: "Downtown Campus", subAddress: "Doors | Gonda West", firstArrival: "6:45 AM", lastDeparture: "5:30 PM"},
  {address: "Downtown Campus", subAddress: "Doors | Charlton West", firstArrival: "6:50 AM", lastDeparture: "5:40 PM"},
  {address: "Downtown Campus", subAddress: "Doors | Mary Brigh West", firstArrival: "7 AM", lastDeparture: "5:15 PM"},
]

const SHUTTLES_STOPS = [
  {text: "Gift of Life houses"},
  {text: "Hands of Compassion house"},
  {text: "Hope Lodge "},
  {text: "Ronald McDonald House"},
  {text: "Herman House"},
  {text: "Charter House"},
  {text: "Emergency Department entrance"},
  {text: "Baldwin Building entrance"},
  {text: "Generose Building entrance"},
]

export default function PatientShuttle() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <Container>
      <MayoLogo />

      <Back style={{marginTop: 18, marginBottom: 27}}/>

      <TopContainer>
        <Image 
          src={busImage}
          />

        <Title style={{marginBottom: 22}}>
          Patient shuttle service schedule
        </Title>
        <Text style={{marginBottom: 39}}>
          Wheelchair accessible shuttle service provides transportation to and from the downtown, Methodist and Saint Marys campuses.
        </Text>


        <Title style={{color: "#000000", marginBottom: 16}}>
          Hours of operation
        </Title>
        <TimeText style={{marginBottom: 16}}>
          Monday-Friday | 6:45 AM to 5:40 PM
        </TimeText>
        <Text style={{marginBottom: 8}}>
          If you need transportation before 6:45 a.m. please make other arrangements.
        </Text>
        <AdditionalText>
          * No operation on observed holidays
        </AdditionalText>
      </TopContainer>

      <ListBox 
        style={{marginTop: 61, paddingInline: 24, marginBottom: 40, paddingBottom: 12}}
        title={"Routes"}
        subtitle={"Each shuttle stops at the west doors of Gonda, Charlton, and Mary Brigh buildings. Times are estimates and can vary based on the number of stops."}
        Component={LocationListItem}
        list={LOCATIONS_LIST}
      />

      <ListBox
        headerMargin={"0 0 22px 0"}
        title={"Upon request, the shuttle will stop at the following locations:"}
        Component={DottedListItem}
        list={SHUTTLES_STOPS}
        noBorder={true}
      />

      <HL style={{marginTop: 36, marginBottom: 40}}/>

      <MayoCareItem
        image={wheelChairImage}
        imageSize={{width: 64, height: 64}}
        title={"Wheelchair"}
        items={[
          "Wheelchairs are available for use by those with mobility limitations. Upon request, wheelchair transportation to or from appointments is available free of charge to patients and visitors via escort services. To request this service, ask a Mayo Clinic employee at the entrance or in any patient-care area."
        ]}
      />

      <HL style={{marginTop: 40, marginBottom: 30}}/>

      <AdditionalText style={{color: "#000000AF", marginInline: 26}}>
        *Observed holidays: New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day, Christmas Day
      </AdditionalText>

      <HL style={{marginTop: 30, marginBottom: 40}}/>

      <MayoFooter />
    </Container>
  )
}

const Container = styled.div`
  color: #1A1A1A;
  font-family: Abraham;
  
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`
const TopContainer = styled.div`
  margin-left: 26px;
`

const Image = styled.img`
  width: 163px;
  height: 125px;
  margin-bottom: 24px;
`

const Title = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
`

const TimeText = styled.p`
  margin: 0;
  font-size: 19px;
  font-weight: 500;
  color: #000000;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  color: #000000;
`

const AdditionalText = styled.p`
  margin: 0;
  font-size: 16px;
`

const HL = styled.div`
  margin-inline: 26px;
  min-height: 1px;
  background-color: #CCD9FB;
` 